import { useCallback, useRef } from "react";
import { useAuthContext } from "src/hooks/useAuthContext";
import { useWsChannel } from "src/services/WebsocketsProvider";

export default function useChartEvent(chartEventId, onMessage) {
  const { user } = useAuthContext();
  const ref = useRef(onMessage);
  ref.current = onMessage;
  const stable = useCallback((message) => ref.current?.(message.data), []);
  useWsChannel(chartEventId ? `chart-event-${chartEventId}` : null, user?.id, stable);
}